import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/logo.svg";
import { HiX } from "react-icons/hi";
import menu from "../assets/menu.svg";
import { useNavigate } from "react-router-dom"; 

const Navbar = ({ handleScrollToSection }) => {
  const [toggle, setToggle] = useState(false);
  const navRef = useRef(null);
  
  const links = ["Home", "About", "Services", "Careers", "Business"];
  const navigate = useNavigate(); 

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toggle && navRef.current && !navRef.current.contains(event.target)) {
        setToggle(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [toggle]);

  const handleNavigation = (link) => {
    if (window.location.pathname !== "/") {
      navigate("/"); // Navigate to Home if not on Home page
      setTimeout(() => {
        handleScrollToSection(link.toLowerCase());
      }, 100); // Small delay to ensure navigation completes
    } else {
      handleScrollToSection(link.toLowerCase());
    }
    setToggle(false);
  };

  return (
    <nav className="fixed z-50 w-full bg-[rgba(255,255,255,0.01)] backdrop-blur-[40px] " ref={navRef}>
      {/* bg-[rgba(255,255,255,0.01)] */}
    {/* Navbar Container */}
    <div className="flex justify-between items-center  px-5 h-[4rem] sm:h-[5rem] text-white" >
      
      {/* Logo Section */}
      <div className=" flex items-center w-[9rem]">
        <img
          src={logo}
          alt="logo"
          className="w-[5rem] md:w-[6rem] lg:w-[7rem] cursor-pointer"
          onClick={() => handleNavigation("home")}
        />
      </div>
  
      {/* Desktop Navigation */}
      <div className={` md:flex space-x-8 hidden`}>
        {links.map((link) => (
          <button
            key={link}
            onClick={() => handleNavigation(link.toLowerCase())}
            className="relative rubik-medium  group"
          >
            <div className="relative z-10 w-[70px]">{link}</div>
            <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-blue-500 group-hover:w-full transition-all duration-300"></span>
          </button>
        ))}
      </div>
  
      {/* Menu Icon for Mobile */}
      <div className="flex justify-end items-center w-[9rem]  md:invisible">
      <button
        className="w-6 h-6 "
        onClick={() => setToggle(!toggle)}
      >
        {toggle ? <HiX size={24} /> : <img src={menu} alt="menu" className="w-6 h-6" />}
      </button>
      </div>
    </div>
  
    {/* Mobile Menu Dropdown */}
    <div
      className={`flex flex-col items-center space-y-4 transition-all duration-500 ease-in-out  md:hidden ${
        toggle ? "py-4 max-h-[15rem] " : "max-h-0 overflow-hidden"
      }`}
    >
      {links.map((link) => (
        <button
          key={link}
          onClick={() => handleNavigation(link.toLowerCase())}
          className={`relative rubik-medium text-white group transition-opacity duration-500 ease-in-out  ${
            toggle ? "opacity-100 delay-200" : "opacity-0 delay-0"
          }`}
        >
          <span className="relative z-10">{link}</span>
          <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-blue-500 group-hover:w-full transition-all duration-300"></span>
        </button>
      ))}
    </div>
  </nav>
  
  );
};

export default Navbar;
